import React, { useState } from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai'

import 'react-circular-progressbar/dist/styles.css'

const DBJus = props => {
  const {
    data,
    showPartes,
    score_parental: scoreParental,
    score_societario: scoreSocietario,
    showScores,
    onClick,
    processosVinculados,
    mode
  } = props

  const [open, setOpen] = useState(false)

  return (
    <div
      className={mode ? 'juridico-card ' : 'juridico-card btn-card-juridico'}
      style={
        mode
          ? { borderTop: 'none', marginTop: '0' }
          : { borderTop: '2px solid #00b07d' }
      }
    >
      {data && data.classes && (
        <div>
          <div className='juridico-classes mr-2'>{data && data.nup}</div>
          <div className='juridico-classes'>{data.classes}</div>
        </div>
      )}

      <div className='row justify-content-start no-gutters'>
        {showScores && (
          <div className='score'>
            <div className='label'>Score de Pessoas Físicas</div>
            <div className='value'>
              <CircularProgressbar
                maxValue={1}
                value={parseFloat(scoreParental).toFixed(3)}
                text={`${parseFloat(scoreParental * 100).toFixed(0)}%`}
              />
            </div>
          </div>
        )}

        {showScores && (
          <div className='score'>
            <div className='label'>Score de Pessoas Jurídicas</div>
            <div className='value'>
              <CircularProgressbar
                maxValue={1}
                value={parseFloat(scoreSocietario).toFixed(3)}
                text={`${parseFloat(scoreSocietario * 100).toFixed(0)}%`}
              />
            </div>
          </div>
        )}

        {data && data.classes && (
          <div className='col-auto juridico-block'>
            <div className='label'>assuntos</div>
            <div className='value valueH1'>{data.assuntos}</div>
          </div>
        )}

        <div className='col-12' />

        <div className='col-auto juridico-block'>
          <div className='label'>diário</div>
          <div className='value'>{data && data.diario}</div>
        </div>

        <div className='col-auto juridico-block'>
          <div className='label'>estado</div>
          <div className='value'>{data && data.estado}</div>
        </div>

        <div className='col-auto juridico-block'>
          <div className='label'>justiça</div>
          <div className='value'>{data && data.justica}</div>
        </div>

        <div className='col-auto juridico-block'>
          <div className='label'>valor</div>
          <div className='value'>{(data && data.valor) || '-'}</div>
        </div>

        {data.vinculadosMap && (
          <div className='col-auto juridico-block'>
            <div className='label'>processo(s) vinculado(s)</div>
            {data?.vinculadosMap.map((item, index) => (
              <div className='value' key={`${item}-${index}`}>
                {item}
              </div>
            ))}
          </div>
        )}

        {showPartes &&
          Object.entries(
            data.partes.reduce((obj, { tipo, nome }) => {
              tipo = tipo.replace(/_/g, ' ')
              if (obj[tipo]) {
                obj[tipo].push(nome)
              } else {
                obj[tipo] = [nome]
              }

              return obj
            }, {})
          ).map(([tipo, nomes]) => (
            <div className='col-auto juridico-block' key={tipo}>
              <div className='label'>{tipo}</div>
              <div className='value valueH2' style={{ paddingTop: '5px' }}>
                {nomes.map((nome, index) => (
                  <span
                    key={(nome + index).toString()}
                    className='juridico-parte'
                  >
                    {nome}
                  </span>
                ))}
              </div>
            </div>
          ))}
        <div className='col-12'>
          <div className='mt-3'>
            <button
              type='button'
              className='btn btn-primary'
              onClick={mode ? null : () => onClick(data)}
            >
              Ver detalhes
            </button>
          </div>
        </div>
        {processosVinculados.length > 0 && (
          <>
            <div className='col-12'>
              <div
                className='mt-3'
                style={{ cursor: 'pointer' }}
                onClick={() => setOpen(prev => !prev)}
              >
                {open ? (
                  <>
                    <AiOutlineMinusCircle /> Ocultar processos vinculados
                  </>
                ) : (
                  <>
                    <AiOutlinePlusCircle /> Ver processos vinculados
                  </>
                )}
              </div>
            </div>
            {open && (
              <>
                <div className='col-1' />
                <div className='col-11'>
                  {processosVinculados.map((processo, key) => {
                    const nup = processo.nup.replace(/\D/g, '')

                    return (
                      <DBJus
                        data={processo}
                        key={`sub-processo-${nup}-${key}`}
                        showPartes={showPartes}
                        showScores={showScores}
                        score_parental={processo.scoreParental}
                        score_societario={processo.scoreSocietario}
                        processosVinculados={[]}
                        onClick={onClick}
                      />
                    )
                  })}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DBJus
